__turbopack_context__.v({
  "centerContent": "Veileder-module__YJeNZq__centerContent",
  "noBorder": "Veileder-module__YJeNZq__noBorder",
  "veileder": "Veileder-module__YJeNZq__veileder",
});
